/**
 * LockedPaidAdsTile — read-only stub for the Paid Ads section.
 *
 * Mirrors the existing `stripe_gated` KpiCard pattern from
 * `AdminAnalyticsPage.jsx` (Pluckonomics) — see that file for the
 * canonical implementation. This tile follows the same visual
 * treatment (— value + orange badge) with the copy "activates with
 * ad campaigns" per Commit C dispatch §3.
 *
 * NO new abstraction — a dedicated component instead of extending
 * KpiCard because the tile is intentionally interaction-less and
 * carries no value / delta.
 */
import React from "react";
import { Card, CardContent } from "@/components/ui/card";

export default function LockedPaidAdsTile() {
  return (
    <Card
      data-testid="analytics-paid-ads-locked-tile"
      data-display-state="ads_gated"
      style={{
        background: "var(--pp-v3-surface)",
        borderColor: "var(--pp-border)",
      }}
    >
      <CardContent className="p-5">
        <div
          className="text-[12px] font-bold uppercase tracking-[0.06em]"
          style={{ color: "var(--pp-text-soft)" }}
        >
          Paid Ads
        </div>
        <div
          className="mt-2 text-3xl font-semibold tracking-tight"
          style={{ color: "var(--pp-text-soft)" }}
          data-testid="analytics-paid-ads-locked-tile-value"
        >
          —
        </div>
        <div
          className="mt-2 inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold"
          style={{
            background: "rgba(248, 150, 35, 0.12)",
            color: "var(--pp-orange)",
          }}
          data-testid="analytics-paid-ads-locked-tile-badge"
        >
          activates with ad campaigns
        </div>
      </CardContent>
    </Card>
  );
}
